import axios from 'axios'

// 添加笔记分类
export const addNoteCategory = (userName, categoryData) => {
  return axios.post(`/notes/user/${userName}/addCategory`, categoryData)
}

// 添加笔记
export const addNote = (userName, categoryName, noteData) => {
  return axios.post(`/notes/user/${userName}/cateGoryName/${categoryName}/addNote`, noteData)
}

// 更新笔记
export const updateNote = (userName, id, noteData) => {
  return axios.put(`/notes/user/${userName}/updateNote/${id}`, noteData)
}

// 更新分类
export const updateCategory = (userName, oldCategoryName, categoryData) => {
  return axios.put(`/notes/user/${userName}/updateCategory/${oldCategoryName}`, categoryData)
}

// 查找笔记分类
export const getNoteCategories = (userName) => {
  return axios.get(`/notes/user/${userName}/getNoteCategory`)
}

// 查找笔记（分页，默认每页20条，倒序）
export const getNotesByCategory = (userName, categoryName, pageNo = 1, pageSize = 20) => {
  return axios.get(`/notes/user/${userName}/category/${categoryName}/getNotes`, {
    params: { pageNo, pageSize }
  })
}

// 删除分类
export const deleteCategory = (userName, name) => {
  return axios.delete(`/notes/user/${userName}/deleteCategory/${name}`)
}

// 删除笔记
export const deleteNote = (id) => {
  return axios.delete(`/notes/deleteNotes/${id}`)
}
